module.exports = __webpack_public_path__ + "static/Cyclop-1f63a548e71ad2d0fa18f5ea28fa7783.jpg";